import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-bill-number-wise-report',
  templateUrl: './bill-number-wise-report.component.html',
  styleUrls: ['./bill-number-wise-report.component.scss']
})
export class BillNumberWiseReportComponent implements OnInit {
  document_file: any = null;
  businessGroups: any=[];
  selectedBusinessGroupId: any=[];
  from_date: any;
  to_date: any;
  selected_business_group_id:any;
  is_document_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  selectedOption:any
  route_disabled=true;
  all_id_list = []
  
  
  constructor(private http: HttpService) {
    // this.http.getBooths().subscribe((data: any[]) => {
    //   console.log(data);
    //   this.selectedBusinessGroupId=data;
    //   console.info(this.selectedBusinessGroupId)
    //   this.businessGroups = data.filter((item: any) => item.business_group_id === 1).map((item: any) => item.name);
    //   console.info(this.businessGroups);
    // }, (error) => {
    //   console.log(error);
    // });
    this.http.getBooths().subscribe((data: any) => {
      console.log(data);
      const filteredData = data.filter((item: any) => item.business_group_id === 1);
      filteredData.forEach((item: any) => {
        const option = { id: item.id, name: item.name };
        this.businessGroups.push(option);
      });
      console.info(this.businessGroups);
      this.businessGroups.forEach(element => {
        this.all_id_list.push(element.id)
      });
      this.selectedOption = this.all_id_list
    }, (error) => {
      console.log(error);
    });
   }

  ngOnInit() {
    
  }
  changeEvent() {
    this.document_file = null;
  }
  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'business_id': this.selectedOption,
      // 'business_group_id':this.businessGroups['name'],
      
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.http.serveRelianceBillNumWiseReport(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }
  // downloadClicked() {
  //   const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
  //   const downloadLink = document.createElement("a");
  //   const fileName = this.document_file['file_name'];
  //   downloadLink.href = linkSource;
  //   downloadLink.download = fileName;
  //   downloadLink.click();
  // }
  downloadClicked() {
    const linkSource = 'data:application/excel;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  checkboxChanged(event) {
    if (event.checked) {
      this.selectedOption = this.all_id_list;
      this.route_disabled = true;
    } else {
      this.selectedOption = [];
      this.route_disabled = false;
    }
  }
}
